import { IUser } from '@epicuro-next/data/users';
import { createEntityAdapter, EntityState } from '@ngrx/entity';
import { createReducer, on } from '@ngrx/store';

import { UserEntity } from './model';
import {
  loadUsers,
  updateUserEntityImage,
  upsertUserEntities,
} from './user-entities.actions';

export type UserEntitiesState = EntityState<UserEntity>;

export const adapter = createEntityAdapter<UserEntity>({
  selectId: ({ userExternalId }) => userExternalId,
  sortComparer: false,
});

export const initial = adapter.getInitialState();
export const reducer = createReducer<UserEntitiesState>(
  initial,
  on(upsertUserEntities, (state, { entities }) =>
    adapter.upsertMany(entities ?? [], state),
  ),
  on(loadUsers, (state, { ids }) =>
    adapter.upsertMany(
      ids.map((id) => ({ userExternalId: id, loading: true })),
      state,
    ),
  ),
  on(updateUserEntityImage, (state, { externalId, imageLink }) =>
    adapter.updateOne(
      {
        id: externalId,
        changes: {
          user: {
            ...(state.entities[externalId]?.user as IUser),
            imageLink,
          },
        },
      },
      state,
    ),
  ),
);
